import { KnowledgeBaseView } from './components/knowledgeBase';
import { SettingsChatbotsMimView } from './components/mim';

export const MimWrapper = (): JSX.Element => {
  return (
    <>
      <SettingsChatbotsMimView />
      <KnowledgeBaseView />
    </>
  );
};
